import EmailIcon from '@mui/icons-material/MailOutlineRounded';
import { Divider, Stack, Typography } from "@mui/material";
import makeStyles from '@mui/styles/makeStyles';
import moment from "moment";
import React, { memo } from "react";
import { scrollbarStyle } from "../../../shared/dashboard";
import EmailContent from "../dashboard-query-answer/EmailContent";

const useStyles = makeStyles((theme) => ({
    body: {
        width: '100%',
        height: '100%',
        padding: '0 16px',
        overflowX: 'hidden',
        overflowY: 'auto',
        ...scrollbarStyle,
    },
    container: {
        display: 'flex',
        width: '100%',
        height: '100%',
        alignItems: 'flex-start',
        justifyContent: 'flex-start',
        background: '#f8fafc',
        border: `1px solid #e2e8f0`,
        boxShadow: '0px 4px 10px -1px rgba(16, 24, 40, 0.06)',
        borderRadius: 8,
        padding: 20,
        breakInside: 'avoid',
        transition: '0.05s ease-in-out',
    },
    subject: {
        display: '-webkit-box',
        width: 'fit-content',
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: 'bold',
        color: '#0f172a',
        overflow: 'hidden',
        WebkitLineClamp: 1,
        WebkitBoxOrient: 'vertical',
        textOverflow: 'ellipsis',
        textTransform: 'capitalize',
        wordBreak: 'break-all',
    },
    ownership: {
        fontFamily: 'Lato',
        fontSize: '1rem',
        fontWeight: '500',
        color: theme.colors.neutral['500'],
    },
    owner: {
        fontFamily: 'Lato',
        fontSize: '0.9rem',
        color: '#475569',
    },
    timestamp: {
        fontFamily: 'Lato',
        fontSize: '0.8rem',
        fontWeight: 500,
        color: '#64748b',
        textAlign: 'right',
    },
    icon: {
        width: 28,
        height: 28,
    },
    icon20: {
        width: 20,
        height: 20,
        fill: '#475569'
    },
}));

const EmailsContentCard: React.FC<{ emailActivities: any[] }> = ({ emailActivities }) => {
    const classes = useStyles();

    if (!emailActivities.length)
        return (<></>);

    return (<>
        <Stack className={classes.body} spacing={2} alignItems="flex-start">
            {emailActivities.map((emailBody) => (
                <Stack direction="column" className={classes.container}
                    alignItems="flex-start" justifyContent="center"
                    width="100%" py={1} key={'emails-content-card-192-' + emailBody?.id}>
                    <Stack direction="row" alignItems="center" justifyContent="space-between" width="100%">
                        <Typography className={classes.subject} width="100%">
                            {emailBody?.subject?.replace('Fwd:', '')?.replace('Fw:', '') || '<Untitled>'}
                        </Typography>
                        <Typography className={classes.timestamp} width="30%">
                            {`${moment(emailBody?.createdAt).fromNow()}`}
                        </Typography>
                    </Stack>
                    <Stack direction="row" spacing="4px" alignItems="center" justifyContent="flex-start" my={1}>
                        <EmailIcon className={classes.icon20} />
                        <Typography component="span" className={classes.owner} display="inline" pl="4px">
                            {!!emailBody?.from ? emailBody?.from.replace(/<.*?>/g, '').trim() : 'N/A'}
                        </Typography>
                    </Stack>
                    <Divider sx={{ width: '100%', my: 1 }} />
                    <EmailContent content={emailBody!} />
                </Stack>
            ))}
        </Stack>
    </>);
};

export default memo(EmailsContentCard);
